import script from "./DraftCollections.vue?vue&type=script&setup=true&lang=js"
export * from "./DraftCollections.vue?vue&type=script&setup=true&lang=js"

import "./DraftCollections.vue?vue&type=style&index=0&id=3a16ad95&lang=scss&scoped=true"
script.__scopeId = "data-v-3a16ad95"

export default script